import { AbortControllerManager } from '../abortControllerManager';
import { authClient } from '../client';
import { INotificationAppointments } from '@/types';
import { ITemplateResponse } from '@/types/common';

class NotificationsApi extends AbortControllerManager {
  private readonly NOTIFICATIONS_URL = '/v2/notifications';

  constructor() {
    super();
  }

  getNotifications(
    institution_id?: string,
  ): Promise<ITemplateResponse<INotificationAppointments[]>> {
    const signal = this.createAbortController('getNotifications');
    const qp = institution_id
      ? new URLSearchParams({ institution_id }).toString()
      : '';
    return authClient.get(`${this.NOTIFICATIONS_URL}?${qp}`, { signal });
  }

  readNotifications(ids: string[]): Promise<void> {
    const signal = this.createAbortController(
      `readNotifications: ${ids.join(', ')}`,
    );
    const url = `${this.NOTIFICATIONS_URL}/mark-read`;
    return authClient.post(url, { ids }, { signal });
  }

  deleteNotifications(): Promise<void> {
    const signal = this.createAbortController('deleteNotifications');
    return authClient.delete(this.NOTIFICATIONS_URL, { signal });
  }
}

export const notificationsApi = new NotificationsApi();
